import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiBaseUrl: 'https://enterprise-connect.aflacqa.com/e-aide-admin-1/v1',
  aecNamespaceId: 'aecx-aide-staging-syst',
  discoveryPromptArn: 'arn:aws:bedrock:us-east-1:690687753728:prompt/332CBS99H5:1',
  auth: {
    authorizationEndpoint: 'https://enterprise-connect.aflacqa.com/a-authorization-1/v1/user-types/producer/as/authorization.oauth2',
    tokenEndpoint: 'https://enterprise-connect.aflacqa.com/a-authorization-1/v1/user-types/producer/as/token.oauth2',
    revocationEndpoint: 'https://enterprise-connect.aflacqa.com/a-authorization-1/v1/user-types/producer/as/revoke_token.oauth2',
    userinfoEndpoint: 'https://enterprise-connect.aflacqa.com/a-authorization-1/v1/user-types/producer/idp/userinfo.openid',
    clientId: 'acrtaide',
    redirectUri: window.location.origin + '/oauth/callback',
    scope: 'openid',
    autoLogoutSeconds: 3600,
    tokenRefreshBufferSeconds: 300,
  },
};
